import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import cssVars from 'css-vars-ponyfill';

if (environment.production) {
  enableProdMode();
}

cssVars({
  include: 'style',
  onlyLegacy: true,
  watch: true
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
